import {
  zlbCostControlFeeItemFurnitureEquipmentTypeGet,
  zlbCostControlFeeItemLecturerLevelGet,
  zlbCostControlFeeItemMeetingLevelGet,
  zlbCostControlFeeItemPersonnelLevelTypeGet,
  zlbCostControlFeeItemSavePost,
  zlbCostControlFeeItemTrainingLevelGet,
  zlbCostControlFeeItemTravelTypeGet,
  zlbCostControlStandardCheckContainsPost,
  zlbCostControlStandardDeleteIdDelete,
  zlbCostControlStandardSavePost,
} from '@/api/zlbCostControl';
import { zlbApiExpenseAddressGet } from '@/api/zlbExpense';
import { notification } from 'doraemon';
import { cloneDeep } from 'lodash';
import { pagePrivileges } from 'src/services/user';
import {
  fetchAddress,
  getCostControlActionList,
  getCostControlStandardDetail,
  getCostControlStrategyList,
  getCostStandardList,
} from '../services/index';
import { formatTreeData, TreeToMap } from '../util';

const responseErrorHandle = res => {
  const { success, message } = res;
  if (!success) {
    notification.error({
      message: message || '请求出错了',
    });
  }
  return success;
};

const formatTree = (tree = []) => {
  if (tree.length) {
    tree?.forEach(item => {
      item.label = item.name;
      item.value = item.code;
      if (item.children) formatTree(item.children);
    });
  }
};

export default {
  namespace: 'feeControl',
  state: {
    districtTree: [],
    districtMap: {},
    costRules: [],
    districts: [],
    orgROS: [],
    costControlId: '',
    existNum: 0,
    orgExistNum: 0,
    feeItemConfigExtendData: {},
    tabBar: {
      wholeProvinceList: [], // 住宿全量省份
      provinceList: [], // 短途部分已经添加省份
    },
    formInstanceObj: {
      basic: null,
      trafficForms: [],
      trafficDriveForms: [],
      hotelForms: [],
      foodForms: [],
      shortDistanceForms: [],
      miscellaneousForms: [],
      meetingHotelForms: [],
      meetingFoodForms: [],
      meetingOtherForms: [],
      trainingTeachForms: [],
      trainingFoodForms: [],
      trainingHotelForms: [],
      trainingOtherForms: [],
      trainingIncidentalForms: [],
      receptionMealForms: [],
      receptionOtherForms: [],
      purchaseForms: [],
      furnitureForms: [],
      equipmentForms: [],
      overtimeForms: [],
    },
    meetingLevel: [],
    trainingLevel: [],
    address: [],
    travelType: [],
    lecturerLevel: [],
    furniture: [],
    equipment: [],
    personnelLevel: [],
    basicData: {},
  },
  effects: {
    // 差旅类型
    *getCostControlActionList({ payload }, { call }) {
      const res = yield call(getCostControlActionList, payload);
      responseErrorHandle(res);
      return res;
    },
    // 查询区划树
    *getDistrictTree({ payload = { level: 3 } }, { call, put }) {
      const result = yield call(zlbApiExpenseAddressGet, payload);
      // 格式化
      formatTree(result);
      yield put({
        type: 'update',
        payload: {
          districtTree: result || [],
          districtMap: TreeToMap(result || []),
        },
      });
      return result;
    },
    // 查询费控事件列表
    *fetchFeeTravelType({ payload }, { call, put }) {
      const res = yield call(zlbCostControlFeeItemTravelTypeGet, payload);
      yield put({
        type: 'update',
        payload: {
          travelTypes: res || [],
        },
      });

      return res;
    },
    // 根据费控事件查询费控规则列表
    *getCostControlStrategyList({ payload }, { call }) {
      const res = yield call(getCostControlStrategyList, payload);
      responseErrorHandle(res);
      return res;
    },
    // 保存费用规则
    *saveCostStandard({ payload }, { call }) {
      const result = yield call(zlbCostControlStandardSavePost, payload);
      return result;
    },
    // 费控规则标准查询
    *getCostStandardList({ payload }, { call }) {
      const res = yield call(getCostStandardList, payload);
      responseErrorHandle(res);
      return res;
    },
    // 根据id查询费控标准
    *getCostControlStandardDetail({ payload }, { call, put }) {
      const res = yield call(getCostControlStandardDetail, payload);
      responseErrorHandle(res);

      yield put({
        type: 'update',
        payload: {
          districts: res.result.districts || [],
          orgROS: res.result.orgROS || [],
          costControlId: payload.costControlId,
          existNum: 0,
          orgExistNum: 0,
        },
      });

      return res;
    },
    // 删除费用标准规则
    *deleteCostStandard({ payload }, { call }) {
      const result = yield call(zlbCostControlStandardDeleteIdDelete, payload);
      return result;
    },

    // 查询区划是否存在费控标准中
    *queryDistrictIsCostStandard({ payload }, { call, put }) {
      const result = yield call(zlbCostControlStandardCheckContainsPost, payload);

      yield put({
        type: 'update',
        payload: {
          districts: result?.checkList || [],
          existNum: result?.existNum || 0,
        },
      });
      return result;
    },
    // 前端页面资源鉴权查询
    *pagePrivileges({ payload }, { call }) {
      const res = yield call(pagePrivileges, payload);
      return res;
    },

    *saveFeeItems({ payload }, { call }) {
      try {
        yield call(zlbCostControlFeeItemSavePost, payload);
        return false;
      } catch (e) {
        return true;
      }
    },
    // 地址
    *getAddress({ payload }, { call, put }) {
      const res = yield call(fetchAddress, payload);
      yield put({
        type: 'update',
        payload: {
          address: formatTreeData(res),
        },
      });
      return res;
    },
    // 差旅分类
    *getTravelType({ payload }, { call, put }) {
      const res = yield call(zlbCostControlFeeItemTravelTypeGet, payload);
      yield put({
        type: 'update',
        payload: {
          travelType: res,
        },
      });
      return res;
    },
    // 会议分类
    *getMeetingLevel({ payload }, { call, put }) {
      const res = yield call(zlbCostControlFeeItemMeetingLevelGet, payload);
      yield put({
        type: 'update',
        payload: {
          meetingLevel: res,
        },
      });
      return res;
    },

    // 培训等级
    *getTrainingLevel({ payload }, { call, put }) {
      const res = yield call(zlbCostControlFeeItemTrainingLevelGet, payload);
      yield put({
        type: 'update',
        payload: {
          trainingLevel: res,
        },
      });
      return res;
    },
    // 讲师
    *getLecturerLevel({ payload }, { call, put }) {
      const res = yield call(zlbCostControlFeeItemLecturerLevelGet, payload);
      yield put({
        type: 'update',
        payload: {
          lecturerLevel: res,
        },
      });
      return res;
    },
    // 家具
    *getFurniture({ payload }, { call, put }) {
      const res = yield call(zlbCostControlFeeItemFurnitureEquipmentTypeGet, { type: 1 });
      yield put({
        type: 'update',
        payload: {
          furniture: res,
        },
      });
      return res;
    },
    // 设备
    *getEquipment({ payload }, { call, put }) {
      const res = yield call(zlbCostControlFeeItemFurnitureEquipmentTypeGet, { type: 2 });
      yield put({
        type: 'update',
        payload: {
          equipment: res,
        },
      });
      return res;
    },
    *getPersonnelLevel({ payload }, { call, put }) {
      const res = yield call(zlbCostControlFeeItemPersonnelLevelTypeGet, payload);
      yield put({
        type: 'update',
        payload: {
          personnelLevel: res,
        },
      });
      return res;
    },
  },
  reducers: {
    setFeeItemConfigExtendDataDTO(state, { payload: { name, instance } }) {
      return {
        ...state,
        feeItemConfigExtendData: {
          ...state.feeItemConfigExtendData,
          [name]: instance,
        },
      };
    },
    addFeeItemConfigExtendDataDTO(state, { payload: { name, instance } }) {
      if (state.feeItemConfigExtendData[name]) {
        state.feeItemConfigExtendData[name].push(instance);
      } else {
        state.feeItemConfigExtendData[name] = [];
        state.feeItemConfigExtendData[name].push(instance);
      }

      return {
        ...state,
        feeItemConfigExtendData: cloneDeep(state.feeItemConfigExtendData),
      };
    },
    setTabBar(state, { payload: { name, list } }) {
      return {
        ...state,
        tabBar: {
          ...state.tabBar,
          [name]: cloneDeep(list),
        },
      };
    },
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    // 初始化表单实例
    addForms(state, { payload: { name, form, indexCode, formType, errList } }) {
      state.formInstanceObj[name].push({
        form,
        indexCode,
        formType,
        errList,
      });
      return {
        ...state,
        formInstanceObj: {
          ...state.formInstanceObj,
          [name]: state.formInstanceObj[name],
        },
      };
    },
    // setForms是为了拿到多个表单的errList显示左侧的必填标识
    setForms(state, { payload: { name, form, indexCode, formType, errList } }) {
      const target = state.formInstanceObj[name].find(
        i => i.indexCode === indexCode && i.formType === formType,
      );
      target.form = form;
      target.errList = errList;
      return {
        ...state,
        formInstanceObj: {
          ...state.formInstanceObj,
          [name]: cloneDeep(state.formInstanceObj[name]),
        },
      };
    },
    setBasicForms(state, { payload: { form } }) {
      return {
        ...state,
        formInstanceObj: {
          ...state.formInstanceObj,
          basic: form,
        },
      };
    },
    // 设置 error
    setFormsBatch(state, { payload: { name, arr } }) {
      arr?.forEach(item => {
        const target = state.formInstanceObj[name].find(
          i => i.indexCode === item.indexCode && i.formType === item.formType,
        );
        target.form = item.form;
        target.errList = item.form.getFieldsError()?.map(i => i.errors);
      });
      return {
        ...state,
        formInstanceObj: {
          ...state.formInstanceObj,
          [name]: cloneDeep(state.formInstanceObj[name]),
        },
      };
    },
  },
};
